import utils from '@/mixins/utils'
import { api, apiPublic } from '@/plugins/axios.js'
import store from '@/store/store'

export async function rulesCopilot(item) {
  let template = []
  if (item.nu_cns == null && item.nu_cpf == null) {
    template.push({
      title: 'O cadastro ainda está sem CNS e sem CPF',
      text: `Cadastro não identificado. O cadastro desta pessoa está sem CNS e sem o CPF. Todos os registros de atendimentos, visitas e vacinação vinculados a ele ficam no e-SUS PEC, mas não serão transferidos para o SISAB, RNDS ou SUS Digital ou os relatórios identificados do e-SUS. Recomenda-se atualizar o cadastro informando o CPF e na falta deste, informar o CNS para evitar perda de dados em virtude do cadastro não identificado. Apenas estrangeiros, população em situação de rua, e outros grupos que não tem a possibilidade de obter o CNS ou o CPF são admitidos nesta condição.
      `,
    })
  }

  if (item.nu_cns == null) {
    template.push({
      title: 'O cadastro ainda está sem CNS',
      text: `Recomenda-se atualizar o cadastro com o CNS, que começa com o número 7 que é definitivo. Os CNS que começam com 1, com 2, 898 ou outro dígito tendem a não ser ainda, na maioria das vezes, um CNS definitivo. Atualizar o cadastro com o CNS definitivo ajuda a evitar duplicações e perda de dados. Também deve-se evitar usar do CNS que está presente na DNV, pois ele não está cadastrado no CADSUS e seu uso vai gerar perda de dados.`,
    })
  }

  if (item.duplicado != null && item.duplicado != '0') {
    template.push({
      title: 'O cadastro está duplicado',
      text: `Recomenda-se procurar o coordenador da UBS para realizar a unificação deste cadastro em PEC >> Gestão de cadastros >> Unificação de Cadastros. As vezes, o numero de CPF ou CNS aqui identificado não pertence a esta pessoa, então para não unificar pessoas diferentes, é ideal verificar no site da Receita Federal se o nº de CPF é dessa pessoa mesmo e também verificar no CADSUS se o número de CNS é dessa pessoa mesmo. Se verificação anteriormente recomendada constatar que o CPF ou o CNS não é dessa pessoa, então não deve-se unificar, deve-se atualizar o cadastro conforme os dados da Receita Federal e do CADSUS. A unificação de cadastros resolve, especialmente, o problema onde os atendimentos, vacinas e visitas estão divididos entre dois prontuários diferentes no e-SUS PEC. É importante ter cuidado ao unificar, se a unificação juntar prontuários de duas pessoas diferentes, não tem ainda como desfazer essa ação.
      `,
    })
  }

  if (item.unificado != null && item.unificado == '1') {
    template.push({
      title: 'Este cadastro foi unificado',
      text: `Se observar alguma divergência de dados, então recomanda-se verificar se a unificação não foi realizada com CNS ou CPF de pessoas diferentes. A verificação pode ser feita no site da Receita Federal se o nº de CPF é dessa pessoa mesmo e também verificar no CADSUS se o número de CNS é dessa pessoa mesmo. Os registros de atendimentos, visitas e vacinação no cadastro que não tinha nem CPF, nem CNS, no momento do registro, aparecerá no e-SUS PEC ou Centralizador, mas não são transmitidos para o SISAB, RNDS ou SUS Digital.`,
    })
  }

  if (item.nu_cpf == null) {
    template.push({
      title: 'O cadastro ainda está sem CPF',
      text: `Recomenda-se atualizar o cadastro informando o número do CPF. Diferentemente do CNS, onde a pessoa pode ter mais de um número, o CPF tende a ter um único para cada pessoa. O uso do CPF está embasado em:

      1 - DECRETO Nº 10.977, DE 23 DE FEVEREIRO DE 2022 que Regulamenta a Lei nº 7.116, de 29 de agosto de 1983, para estabelecer os procedimentos e os requisitos para a expedição da Carteira de Identidade por órgãos de identificação dos Estados e do Distrito Federal, e a Lei nº 9.454, de 7 de abril de 1997, para estabelecer o Serviço de Identificação do Cidadão como o Sistema Nacional de Registro de Identificação Civil. O qual determina que A Carteira de Identidade é única em âmbito nacional e a sua expedição em ente federativo distinto do local de expedição da primeira via será considerada como segunda via do documento. A Carteira de Identidade adota o número de inscrição no Cadastro de Pessoas Físicas - CPF como registro geral nacional previsto no inciso IV do caput do art. 11.;

      2 - LEI Nº 14.534, DE 11 DE JANEIRO DE 2023, Altera as Leis nºs 7.116, de 29 de agosto de 1983, 9.454, de 7 de abril de 1997, 13.444, de 11 de maio de 2017, e 13.460, de 26 de junho de 2017, para adotar número único para os documentos que especifica e para estabelecer o Cadastro de Pessoas Físicas (CPF) como número suficiente para identificação do cidadão nos bancos de dados de serviços públicos;

      3 - PORTARIA GM/MS Nº 2.236, DE 2 DE SETEMBRO DE 2021, que Altera a Seção I do Capítulo III do Título VII da Portaria de Consolidação GM/MS nº 1, de 28 de setembro de 2017, para dispor sobre o Cadastro Nacional de Usuários do SUS e para estabelecer o uso do número de inscrição no Cadastro de Pessoas Físicas (CPF) como forma preferencial de identificação de pessoas na saúde para fins de registro de informações em saúde e instituir o sistema CONECTE SUS CIDADÃO, atual MEU SUS DIGITAL.`,
    })
  }

  if (item.dt_ultima_ficha == null) {
    template.push({
      title: 'O cadastro ainda está simplificado',
      text: `Parece que o cadastro deste cidadão foi preenchido somente na sua forma simplificada (PEC >> Cidadão). Recomenda-se preencher também a Ficha de Cadastro Individual (FCI) completa, informando o mesmo número de CPF ou CNS informado na ficha simplificada. Para os cidadãos que não procuram mais a assistência prestada no município, sejam residentes, sejam pessoas que buscam atendimentos nas UBS municipal por questão de acessibilidade é necessário realizar uma atualização na Ficha de Cadastro Individual (FCI) através do CDS, e-SUS Território ou app particular, marcando em Saída do cidadão do cadastro a opção Mudança de território. A atualização da FCI pode ser feita por ACS, Recepção, Enfermagem ou Medicina da equipe de saúde eSF ou eAP.`,
    })
  }

  if (
    item.percent_fci_completa != null &&
    Number(item.percent_fci_completa) < 100
  ) {
    template.push({
      title: 'Este cadastro está incompleto',
      text: `Recomenda-se preencher os campos da Ficha de Cadastro Individual (FCI) de forma a deixar o cadastro atualizado, completo e qualificado. Os campos abaixo faltam serem preenchidos:

      ${item.fci_completa}

      `,
    })
  }

  if (
    item.dt_atualizado != null &&
    item.dt_ultima_ficha != null &&
    new Date(item.dt_atualizado) > new Date(item.dt_ultima_ficha)
  ) {
    template.push({
      title: 'Observa-se que a FCI ainda não foi atualizada',
      text: `Ao atualizar o cadastro do cidadão pelo módulo PEC >> Cidadãos, recomenda-se também, ir em PEC >> CDS >> Cadastro individual e atualizar a ficha completa ou comunicar ao ACS responsável pelo cidadão para que a atualização seja realizada. Essa ação deixa o cadastro qualificado, completo e atualizado.`,
    })
  }

  if (item.dt_ultima_ficha !== null) {
    const today = new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, '0')
    const day = String(today.getDate()).padStart(2, '0')
    const formattedDate = `${year}-${month}-${day}`
    let diff = utils.methods.differenceOfDaysBetweenTwoDates(
      item.dt_ultima_ficha,
      formattedDate
    )
    if (
      parseInt(diff) > 366 ||
      item.dt_ultima_ficha == null ||
      item.percent_fci_completa === null ||
      Number(item.percent_fci_completa) < 100
    ) {
      template.push({
        title: 'A FCI está desatualizada',
        text: `Recomenda-se atualizar o cadastro (PEC >> CDS >> Cadastro Individual) na visita domiciliar in loco pelo ACS, ou no próximo contato da pessoa com a UBS. Não se deve unificar, completar ou atualizar no e-SUS PEC o cadastro de cidadãos que estão em óbito. A solução é informar a data do óbito e o número da Declaração de Óbito (DO) nos dois cadastros. Dessa forma, resolve-se a inconsistência. Lembrando que, no caso dos óbitos, é importante também verificar se o registro do óbito foi feito na base do Cartão Nacional de Saúde (CADSUS).`,
      })
    }
  }

  if (item.nu_cns != null || item.nu_cpf != null) {
    try {
      const response = await api.get(
        `/app/cidadao/${store.state.cod_ibge}/${item.nu_cpf}/${item.nu_cns}/cadastros`
      )
      if (response) {
        let quantIdMaster = quantidadeDeObjetosIdMasterDiferentes(response.data)
        let fields = extractFields(response.data)

        let fieldsTemplate = ''
        fields.forEach((el) => {
          fieldsTemplate += `
             ${el.id_dw != null ? 'ID DW:' + el.id_dw : ''}
             ${el.id_master != null ? 'ID MASTER:' + el.id_master : ''}
             ${el.id_pec != null ? 'ID PEC:' + el.id_pec : ''}
             ${el.id_unificado != null ? 'ID UNIFICADO:' + el.id_unificado : ''}
            <br/>
          `
        })

        if (quantIdMaster > 1) {
          template.push({
            title: 'O cadastro tem mais de um ID',
            text: `Esse cadastro tem mais de um identificador (número identificador id da pessoa dentro do sistema. Ideal ter somente um) interno no e-SUS PEC ou Centralizador. Recomenda-se informar ao administrador municipal do e-SUS.
            `,
            textOptional: fieldsTemplate,
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  if (item.fci_completa != null) {
    let fciCompletaParse = item.fci_completa.replace(/^\{|\}$/g, '')
    if (fciCompletaParse.includes('Ocupação')) {
      template.push({
        title: 'Ocupação',
        text: `No caso do cidadão desenvolver outras atividades, como por exemplo, estudante ou pessoas que cuidam da casa (“do lar”) sem finalidade de obter renda, o campo ocupação não deve ser preenchido.

        Ao informar em "Situação no mercado de trabalho" uma das respostas: NÃO TRABALHA, OUTRA ou APOSENTADO/PENSIONISTA, o preenchimento do campo "Ocupação" não é exigido na completude do cadastro.

        Para encontrar facilmente a ocupação de um cidadão ou cidadã que trabalha na agricultura ou como agricultor, a dica é digitar em ocupação as letras "AGRIC". Isso vai trazer todas as possibilidades.`,
      })
    }
  }

  if (item.ine_c != item.ine_fci) {
    template.push({
      title: 'Cadastro em duas equipes diferentes',
      text: `O INE vinculado no cadastro simplificado é ${item.ine_c}, o qual é diferente do INE vinculado a FCI ${item.ine_fci}. Recomenda-se atualizar a FCI e no cadastro simplificado, marcar a opção "Utilizar informações do cadastro individual do cidadão", na opção de vincular a equipe responsável.

      Se tiver um ACS responsável pela micro área onde o cidadão reside, então o ideal é que a atualização da FCI seja feita pelo ACS. Recepcionista, medicina ou enfermagem pode atualizar o cadastro simplificado.`,
    })
  }

  if (
    item.percent_fcdt_completa != null &&
    Number(item.percent_fcdt_completa) < 100
  ) {
    template.push({
      title: 'Cadastro domiciliar incompleto',
      text: `Recomenda-se preencher os campos da Ficha de Cadastro Domiciliar (FCD) do cidadão de forma a deixar o cadastro atualizado, completo e qualificado. Uma sugestão é ir em PEC >> Acompanhamentos >> Território para organizar o cadastro domiciliar e o núcleo familiar e depois com o tablet, para quem usa, atualizar o Cadastro Domiciliar incluindo o georreferenciamento. Os campos abaixo faltam serem preenchidos:

      ${item.fcdt_completa.replace(/^\{|\}$/g, '')}

      `,
    })
  }

  // Lembrete
  // Se o cadastro desta pessoas foi realizado ou atualizado pelo aplicativo e-SUS Território, então deve-se realizar a sincronização do aplicativo com o sistema e-SUS PEC ou centralizador uma vez por dia para não perder os dados. Se o cadastro desta pessoas foi realizado ou atualizado por aplicativo particular, então deve-se falar com o administrador municipal do centralizador para importar os dados pelo menos uma vez por semana. Depois da sincronização com o e-SUS PEC ou importação dos dados no Centralizador, leva-se cerca de 24h para os dados serem processados e aparecerem aqui no painel de monitoramento.
  return template
}

function quantidadeDeObjetosIdMasterDiferentes(data) {
  const uniqueIds = new Set() // Usamos um Set para armazenar IDs únicos

  data.forEach((item) => {
    uniqueIds.add(item.id_master)
  })

  return uniqueIds.size // O tamanho do Set nos dá o número de IDs únicos
}

function extractFields(data) {
  return data.map((item) => ({
    id: item.id,
    id_dw: item.id_dw,
    id_pec: item.id_pec,
    id_master: item.id_master,
    id_unificado: item.id_unificado,
  }))
}
